<template>
	<div>
		<div class="reset-password-animation__display">
			<helio-icon
				class="reset-password-animation__icon"
				token="check"
				color="white"
			/>
			<div class="reset-password-animation__text">
				{{ translation['modified-password'] }}
			</div>
		</div>
		<div class="reset-password-animation reset-password-animation__expand" />
	</div>
</template>

<script>
import { translationMixin } from '@/mixins';

export default {
	name: 'ResetPasswordAnimation',
	mixins: [translationMixin],
	computed: {
		translation() {
			return this.currentTranslation['reset-password-animation'];
		},
	},
};
</script>

<style scoped lang="scss" src="./reset-password-animation.scss" />
